
import React from 'react';
import './App.css';
//import Navbar from './components/Navbar';
//import Navbar from './components/Navbarelements/index'
import { BrowserRouter as Router, Routes, Route}
    from 'react-router-dom';
   // import Templaterenderer from './components/pages/Templaterenderer';
   /* import Subdomainrender from './components/pages/Subdomainrender';
    //import Orderpayment from './components/pages/orderpayment'
    import Graboncampaign from './components/pages/graboncampaign1'
    import Campaignrenderer from './components/pages/Campaignrenderer'
   */
  import Goldies from './components/pages/loyaltrewards' 
    
    function App() {
      return (
    
          <Router>
        
          <Routes>
              <Route path='/:id' element={<Goldies/>}/>
          </Routes>
          </Router>
  );
  }
    
  export default App;